import React from 'react'
import { useShadowOnTopScroll } from './hooks/useShadowOnTopScroll'

export const StickyHeaderOnTopScroll: React.FC<
  React.PropsWithChildren & { shouldConsiderAppHeaderHeight?: boolean }
> = ({ children, shouldConsiderAppHeaderHeight = true }) => {
  const { stickyEl1Ref } = useShadowOnTopScroll(shouldConsiderAppHeaderHeight)

  return <div ref={stickyEl1Ref}>{children}</div>
}
